import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { Td } from '@/trio-ui/Table';

export const Content = styled.div<{ isShowingFilters?: boolean }>`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    .chakra-table__container {
      max-height: ${(props) => `calc(100vh - ${props.isShowingFilters ? '300px' : '230px'})`};
      overflow-y: scroll;
    }
  }
`;

export const TableLink = styled(Link)`
  color: ${(props) => props.theme.colors['primary-60']};
  font-weight: 600;
`;

export const SalaryRangeTd = styled(Td)`
  text-transform: lowercase !important;
  span {
    color: ${(props) => props.theme.colors['neutral-80']} !important;
  }
`;

export const StatusTd = styled(Td)`
  p:before {
    top: 4px !important;
  }
`;

const timeOpenAlert = css`
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.colors['neutral-0']};
  background: #ff991c;
`;

export const TimeOpenText = styled.p<{ days: number }>`
  ${(props) => props.days >= 31 && timeOpenAlert}
`;

export const NotFound = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  height: 410px;
  color: ${(props) => props.theme.colors['neutral-100']};
  p {
    margin-bottom: 24px;
  }
`;

export const NotFoundSubtitle = styled.p`
  font-size: 26px;
  line-height: 30px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-50']};
`;

export const NewJobForm = styled.div<{ isOpened?: boolean }>`
  width: 344px;
  background: ${(props) => props.theme.colors['neutral-10']};
  position: fixed;
  top: 56px;
  right: 0;
  z-index: 9;
  height: calc(100% - 56px);
  box-shadow: -10px 10px 12px 6px rgba(0, 0, 0, 0.07);
  transition: translate 0.3s ease;
  translate: ${(props) => (props.isOpened ? '0px 0px;' : '360px 0px')};
`;
